import clsx from 'clsx';
import PropTypes from 'prop-types';

import { ScoreType } from '../../../api/types';
import { TeamLogo } from '../../team-logo/team-logo';

import { customizations } from './market-card-competitors.customizations';

import './market-card-competitors.scss';

export function MarketCardCompetitors({ nameA, nameB, logoA, logoB, totalScore, isLive }) {
  const { isTeamLogoHidden } = customizations.useCustomizations();
  return (
    <div className={clsx('sb-MarketCardCompetitors', isTeamLogoHidden && 'isTeamLogoHidden')}>
      <div className="sb-MarketCardCompetitor">
        {!isTeamLogoHidden && <TeamLogo className="sb-MarketCardCompetitors-logo" imageUrl={logoA} size={58} isHome />}
        <span className="sb-MarketCardCompetitors-name" dir="auto" title={nameA}>
          {nameA}
        </span>
      </div>
      <span className="sb-MarketCardCompetitor-score">{isLive && totalScore?.home}</span>

      <span className="sb-MarketCardCompetitor-score">{isLive && totalScore?.away}</span>
      <div className={clsx('sb-MarketCardCompetitor', isTeamLogoHidden && 'isTeamLogoHidden')}>
        {!isTeamLogoHidden && <TeamLogo className="sb-MarketCardCompetitors-logo" imageUrl={logoB} size={58} />}
        <span className="sb-MarketCardCompetitors-name" dir="auto" title={nameB}>
          {nameB}
        </span>
      </div>
    </div>
  );
}

MarketCardCompetitors.propTypes = {
  nameA: PropTypes.string.isRequired,
  nameB: PropTypes.string.isRequired,
  logoA: PropTypes.string.isRequired,
  logoB: PropTypes.string.isRequired,
  isLive: PropTypes.bool.isRequired,
  totalScore: ScoreType,
};

MarketCardCompetitors.defaultProps = {
  totalScore: undefined,
};
